/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M4.0008 3v8.75h6.2501a.75.75 0 0 1 0 1.5h-6.25V21c0 1.6569 1.3431 3 3 3h7c1.6568 0 3-1.3431 3-3v-7.75h4.132l-1.2197 1.2197a.75.75 0 0 0 1.0607 1.0606L24.0042 12.5l-3.0303-3.0303a.75.75 0 0 0-1.0607 1.0606l1.2197 1.2197h-4.132V3c0-1.6568-1.3432-3-3-3h-7c-1.6569 0-3 1.3432-3 3Z"
    />
    <path
      fill="currentColor"
      d="M.7509 11.75a.75.75 0 0 0 0 1.5h3.25v-1.5h-3.25Z"
    />
  </React.Fragment>,
  'MenuGatewayFilled'
);
